import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { SessionContext } from "../context/SessionContext";
import HomePage from "./HomePage";
import LoadingPage from "./LoadingPage";

const RootRedirector = () => {
  const { session, isLoading } = useContext(SessionContext);

  if (isLoading) {
    return <LoadingPage />;
  }

  return session ? <Navigate to="/chatlistpage" replace /> : <HomePage />;
};

export default RootRedirector;
